import {Button, Dialog, Grid, Typography} from "@mui/material";
import {useEffect, useState} from "react";
import {useFormulario} from "../../Modulo_formularios/Hooks/useFormulario";
import Formulario_Acceso from "../Formularios/Formulario_Acceso";
import {LockPerson} from '@mui/icons-material'
import {where} from "firebase/firestore";
import {obtenerColWheres} from "../../Servicios/BD/obtenerColWheres";
import {obtenerObjLocal} from "../../Servicios/BDLocal/obtenerObjLocal";
import {guardarObjLocal} from "../../Servicios/BDLocal/guardarObjLocal";
import {obtenerDoc} from "../../Servicios/BD/obtenerDoc";


export const useDialogoSeguridad = () => {
    const [cargando, setCargando] = useState(false)
    const [open, setOpen] = useState(true)
    const {props, obtenerEntidad} = useFormulario({valoresDefecto: {}})
    const [datos, setDatos] = useState({})

    const abrir = (e) => {
        setDatos(e)
        setOpen(true)
    }

    const cerrar = (e) => {
        setOpen(false)
        setDatos(e)
        guardarObjLocal({key: 'conductor', obj: e})

    }


    const Dialogo = () => {

        const buscarAcceso = async () => {

            let entidad = await obtenerEntidad()
            let cc = entidad.cc.replaceAll('.', '')

            setCargando(true)
            let w = [where('cc', '==', cc), where('codigo', '==', entidad.codigo), where('estado', '==', 'Activo')]
            let doxs = await obtenerColWheres({col: 'conductores', wheres: w})
            if (doxs.res && doxs.data && doxs.data[0]) {
                cerrar(doxs.data[0])
            }
            setCargando(false)

        }

        return (
            <Dialog open={open} keepMounted fullWidth
                    maxWidth={'xs'}
                    scroll={'body'}
                    sx={{m: -2}}>

                <Grid
                    container
                    justifyContent={'flex-start'}
                    alignItems={'center'}
                    size={12}
                    sx={{p: 3, overflowX: 'hidden'}}
                >

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center'}}>
                        <Typography sx={{fontSize: 24, textAlign: 'center', fontWeight: 800, lineHeight: 1.1}}>Ingresa
                            tu numero de cedula y codigo de acceso</Typography>
                    </Grid>


                    <Grid container size={12} sx={{mt: 4}}>
                        <Formulario_Acceso props={props}/>
                    </Grid>

                    <Grid container size={12} sx={{justifyContent: 'center', mt: 4}}>
                        <Button
                            onClick={() => buscarAcceso()}
                            loading={cargando} startIcon={<LockPerson/>}>Ingresar</Button>
                    </Grid>


                </Grid>


            </Dialog>
        )
    }


    useEffect(() => {
        let conductor = obtenerObjLocal({key: 'conductor'})


        if (conductor) {
            setCargando(true)
            obtenerDoc('conductores', conductor.id).then((dox) =>{
                if (dox.res && dox.data.estado === 'Activo'){
                    cerrar(conductor)
                }
                setCargando(false)
            })


        }
    }, []);
    return {
        Dialogo,
        datos
    }
}